import emailjs from "@emailjs/browser";
import { Cancel } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import { useReducer, useState } from "react";
import { actionConsts, reducer } from "./StateManager";
import { Hbrbackarrow } from "./Mycustomsvgicons";
import { CustomAlertDialog } from "./CustomAlertDialog";
import { useLocation, useNavigate } from "react-router-dom";


const Deleteaccount = () => {
    const [feedbackSent,setFeedbackSent]=useState(false);
    const [sending,setSending]=useState(false)
    const [useremail,setuseremail]=useState("");
    const [uid,setUid]=useState("");
    const [wronguid,setwronguid]=useState(false);
    const [wrongemail,setWrongemail]=useState(false);
    const [success,setSuccess]=useState(false);
    // const [sesexp,setsesexp]=useState(false);
    const [state,dispatch]=useReducer(reducer,{alertMessage: "", showAlert: false, showConfirmDialog: false, vcode: ""});
    const navigate = useNavigate();
    const location = useLocation();
    // const [number_of_tries,setTries]=useState(4);
    // const imageid = format(today,"yyyyMMddHHmmss");
    
    const serviceID = `${process.env.REACT_APP_SERVICEID}`;
    const templateID = `${process.env.REACT_APP_TEMPLATEID}`;
    const publicKey = `${process.env.REACT_APP_PUBLICKEY}`;

    const sendFeedback=(e)=>{
        e.preventDefault();
        setSending(true);
        emailjs.sendForm(serviceID,templateID,e.target,publicKey)
        .then((result)=>{
          if(result.text === "OK"){
              setFeedbackSent(true);
              setSending(false);
          }else{
              setFeedbackSent(false);
              setSending(false);
          }
        }).catch((error)=>{
          console.log(error);
          setSending(false);
        });
      };

      const deleteAccount=async(e)=>{
        e.preventDefault();
        dispatch({type: actionConsts.ALERT_MESSAGE,payload: "This option is temporarily disabled, use the second option to request account deletion"});
        dispatch({type: actionConsts.SHOWALERT,payload: true});
      };

      const handleClosePage=()=>{
        if (location.state && location.state.from) {
            navigate(location.state.from);
        }else{
            navigate("/");
        }
    };


    return ( 
        <div className="deleteaccount">
        {sending && 
        <div style={{position:"fixed",left:"45%",top:"40%"}}> 
            <CircularProgress/> 
        </div>
        }

        {state.showAlert && 
            <CustomAlertDialog alertmessage={state.alertMessage} handleCloseDialog={()=>dispatch({type: actionConsts.SHOWALERT,payload: false})} />
        }

        <div className="flex-row2" style={{width:"100%", gap:"30px"}}>
        <Hbrbackarrow width={"1.8em"} height={"1.8em"} fillColour={"black"} handleClick={() => handleClosePage()}/>
             <h2>Delete Account</h2>
        </div>
       
        <p style={{color:"black",fontWeight:"bold",width:"80%"}}>
            Use the first form to directly delete your account by providing the relevant credentials.
            You can alternatively submit a request for your account to be deleted. The second option may take some 
            few hours to delete your account depending on the number of request to process. <br/><br/>
            <em>FAQ: How do i know my account is deleted?</em> <br/>
            Once your account is deleted, you won't have full access to some features of the App that require 
            user account. Features such as the chat room, Divine Blog, comments on videos and other features 
            that support user generated contents will not be fully available to you <br/><br/>
            <em>FAQ: Can i recover my account after deleting?</em> <br/>
            Yes. you can create a new account with the same credentials. Nevertheless, you cannot create a new 
            account when your account is terminated. <br/><br/>
            <em>FAQ: How many attempts do i have to directly delete my account?</em> <br/>
            To prevent fraudulent activities, you are allowed to use the first option to directly delete your account on four attempts. 
            When all attempts are exhausted, you will be restricted to the second section to delete your account.
        </p>

        <form onSubmit={deleteAccount} className="flex-column2">
            <h3 style={{color:"white"}}>1. Delete account directly</h3>
              <input type="email" value={useremail} required placeholder="email used in creating account"
              onChange={e=>setuseremail(e.target.value.trim())}/>
              <input type="text" value={uid} required placeholder="User ID" 
              onChange={e=>setUid(e.target.value.trim())}/>
              <input style={{
                  color:"white",
                  fontWeight:"bolder",
                  width:"50%",
                  backgroundColor:"red",
                  border:"none"}} 
                  type="submit" value="Delete Account"/>
            </form>

      
          <form onSubmit={sendFeedback} className="flex-column2">
          <h3 style={{color:"white"}}>2. Request account deletion</h3>
            <input type="text" name="from_name" required placeholder="Your name"/>
            <input type="email" name="from_email" required placeholder="email used in creating account"/>
            <textarea style={{width:"100%"}} name="message" rows={10} required placeholder="reason" />
            <input style={{
                color:"white",
                fontWeight:"bolder",
                width:"50%",
                backgroundColor:"red",
                border:"none"}} 
                type="submit" value="Submit"/>
          </form>

                {success && 
                  <div className="toast">
                  <p style={{color:"white",fontWeight:"bold"}}>
                  Account deleted successfully
                 </p> 
                    <svg
                    cursor="pointer"
                    onClick={()=>setSuccess(false)}
                    viewBox="0 0 24 24"
                    fill="white"
                    height="2em"
                    width="2em">
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM17 15.74L15.74 17 12 13.26 8.26 17 7 15.74 10.74 12 7 8.26 8.26 7 12 10.74 15.74 7 17 8.26 13.26 12 17 15.74z" />
                    </svg>
              </div>
                }

              
                {wronguid && 
                  <div className="toast2">
                  <p style={{color:"white",fontWeight:"bold"}}>
                  Incorrect User ID. The user ID you provided is Incorrect.
                 </p> 
                    <svg
                    cursor="pointer"
                    onClick={()=>setwronguid(false)}
                    viewBox="0 0 24 24"
                    fill="white"
                    height="2em"
                    width="2em">
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM17 15.74L15.74 17 12 13.26 8.26 17 7 15.74 10.74 12 7 8.26 8.26 7 12 10.74 15.74 7 17 8.26 13.26 12 17 15.74z" />
                    </svg>
                </div>
                }

                {wrongemail && 
                  <div className="toast">
                  <p style={{color:"white",fontWeight:"bold"}}>
                  Incorrect User email. The email you provided is incorrect.
                 </p> 
                    <svg
                    cursor="pointer"
                    onClick={()=>setWrongemail(false)}
                    viewBox="0 0 24 24"
                    fill="white"
                    height="2em"
                    width="2em">
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM17 15.74L15.74 17 12 13.26 8.26 17 7 15.74 10.74 12 7 8.26 8.26 7 12 10.74 15.74 7 17 8.26 13.26 12 17 15.74z" />
                    </svg>
              </div>
                }
         
            {
                feedbackSent &&
                <div className="toast">
                    <span style={{color:"white",fontWeight:"bold"}}>Feedback sent successfully</span> 
                    <button onClick={()=>setFeedbackSent(false)}><Cancel/></button>
                </div>
            }

    </div>
     );
}
export default Deleteaccount;